// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"44":"6be66861","655":"33b392b8","722":"287b5440"}[chunkId] + ".css";
};